import { Button } from '@/components/ui/common/Button'

interface FormInterface {
  id?: string
  submitText?: React.ReactNode
  onSubmit?: (e: React.FormEvent<HTMLFormElement>) => void
  buttonClassName?: string
  disabled?: boolean
  children: React.ReactNode
  onClick?: (e: React.MouseEvent<HTMLButtonElement>) => void
}

function FormWrap({
  id,
  submitText,
  onSubmit,
  disabled,
  buttonClassName,
  onClick,
  children
}: FormInterface): React.ReactNode {
  return (
    <form
      className="w-full"
      id={id}
      onSubmit={(e: React.FormEvent<HTMLFormElement>) => {
        e.stopPropagation()
        e.preventDefault()
        if (onSubmit) onSubmit(e)
      }}
    >
      <div className="mb-4">{children}</div>
      {submitText && (
        <div className="mt-6 flex w-full justify-center py-1">
          <Button
            className={buttonClassName}
            disabled={disabled}
            onClick={onClick}
            size={'lg'}
            type="submit"
          >
            {submitText}
          </Button>
        </div>
      )}
    </form>
  )
}

export default FormWrap
